import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "@/components/Reveal";
import { REFERENCE_ARTISTS } from "@/data/content";
import { CLIENT_LOGOS } from "@/data/logos";
import { useLang } from "@/i18n";

const LogoMark = ({ logo, big = false }) => (
  <div className="flex items-center justify-center shrink-0 transition-transform duration-500 hover:scale-110">
    <img
      src={logo.src}
      alt="Logo client"
      loading="lazy"
      className={`w-auto object-contain ${
        big ? "h-[4.5rem] sm:h-[5.25rem] max-w-[250px]" : "h-14 sm:h-16 max-w-[210px]"
      }`}
    />
  </div>
);

const Artists = () => {
  const { t } = useLang();
  return (
    <Reveal>
      <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight mb-8">
        {t("refs.artistsH3")}
      </h3>
      <p className="font-serif text-xl lg:text-2xl font-light text-white/80 leading-relaxed" data-testid="artists-list">
        {REFERENCE_ARTISTS.map((a, i) => (
          <span key={a}>
            <span className="transition-colors duration-300 hover:text-gold cursor-default">{a}</span>
            {i < REFERENCE_ARTISTS.length - 1 && <span className="text-gold/50 mx-3">·</span>}
          </span>
        ))}
        <span className="text-gold/50 mx-3">·</span>
        <span className="text-white/30 italic">etc.</span>
      </p>
    </Reveal>
  );
};

export const References = ({ full = false }) => {
  const { t } = useLang();
  return (
  <section id="references" data-testid="references-section" className="py-24 lg:py-32 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-16">
      <Reveal className="mb-14">
        <Overline>{t("ov.references")}</Overline>
        <Artists />
      </Reveal>
      <Reveal>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight">
          {t("refs.logosH2")}
        </h2>
      </Reveal>
    </div>
    {full ? (
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-14">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10" data-testid="logo-wall">
          {CLIENT_LOGOS.map((logo) => (
            <div key={logo.src} className="bg-[#0a0a0a] px-6 py-10 flex items-center justify-center transition-colors duration-500 hover:bg-[#161616]">
              <LogoMark logo={logo} big />
            </div>
          ))}
        </div>
      </div>
    ) : (
      <Reveal>
        <div className="border-y border-white/10 py-10" data-testid="logo-ribbon">
          <Marquee speed={40} gradient={false} pauseOnHover>
            {CLIENT_LOGOS.map((logo) => (
              <span key={logo.src} className="mx-8 inline-flex">
                <LogoMark logo={logo} />
              </span>
            ))}
          </Marquee>
        </div>
      </Reveal>
    )}
  </section>
  );
};
